// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e88d4b72","453":"33612f36"}[chunkId] + ".chunk.js";
};